// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"BasicModal_wrapper__y20EK","container":"BasicModal_container__8ET1N","closeBtn":"BasicModal_closeBtn__CHfjF","modalContent":"BasicModal_modalContent__zgbHX"};